export const GENERATE_UNIQUE_ID = "api/questionnaire/v1/helper/generate-unique-id";
// export const DRAFT_SHORTCUT_HASH_INFO = "api/questionnaire/v1/helper/draft-shortcut-hash-info";
export const HELPER_FILE = "/api/questionnaire/v1/helper/file";
export const CHECK_PAYFORM_EXISTS = "/api/questionnaire/v1/helper/check-payform-exists";
export const GET_BANK_INFO = "/api/questionnaire/v1/helper/get-bank-info";
export const DRAFT_PREVIEW = "/api/questionnaire/v1/draft-preview";
export const DRAFT_COMPANY_DETAILS = "/api/questionnaire/v1/draft/company-details";
export const DRAFT_CONTACT_DETAILS = "/api/questionnaire/v1/draft/contact-details";
export const DRAFT_PAYFORM_DETAILS = "/api/questionnaire/v1/draft/payform-details";
export const DRAFT_ACCOUNT_DETAILS = "/api/questionnaire/v1/draft/account-details";
export const DRAFT_PAYFORM_TECH_DETAILS = "/api/questionnaire/v1/draft/payform-tech-details";
export const DRAFT_MARKETPLACE_DETAILS = "/api/questionnaire/v1/draft/marketplace-details";
export const DRAFT_ATTACHMENTS_DETAILS = "/api/questionnaire/v1/draft/attachments-details";
export const DRAFT_ADDITIONAL_DETAILS = "/api/questionnaire/v1/draft/additional-details";
export const DRAFT_SAVE = "/api/questionnaire/v1/questionnaire/save";
export const REPORT_ERROR = "/api/questionnaire/v1/questionnaire/report-error";
export const REQUEST_CODE = "/api/questionnaire/v1/confirmation/request-code";
export const CONFIRM_CODE = "/api/questionnaire/v1/confirmation/confirm-code";
export const CHANGE_PHONE = "/api/questionnaire/v1/draft-edit/phone-change";
export const PERSONAL_DATA_ADDRESS_SUGGEST = "/api/questionnaire/v1/personal-data/address/suggest";
export const PASSPORT_CHECK = "/api/questionnaire/v1/passport/check";

// -------------------- v2 --------------------
export const DRAFT_ORG_TYPE_V2 = "/api/questionnaire/v2/draft/customer/step0";
export const DRAFT_ACCOUNT_DETAILS_V2 = "/api/questionnaire/v2/draft/customer/step1";
export const DRAFT_COMPANY_DETAILS_V2 = "/api/questionnaire/v2/draft/customer/step2";
export const DRAFT_PAYFORM_TECH_DETAILS_V2 = "/api/questionnaire/v2/draft/customer/step3";
export const DRAFT_ADDITIONAL_DETAILS_V2 = "/api/questionnaire/v2/draft/customer/step4";
export const DRAFT_ATTACHMENTS_DETAILS_V2 = "/api/questionnaire/v2/draft/customer/step5";

export const EMAIL_CONFIRMATION_REQUEST_CODE =
  "/api/questionnaire/v2/confirmation/email/request-code";
export const EMAIL_CONFIRMATION_CONFIRM_CODE =
  "/api/questionnaire/v2/confirmation/email/confirm-code";

// -------------------- Identification (Sber ID и др. провайдеры) --------------------
export const SBERID_INIT = "/api/questionnaire/v2/draft/sberid/init";
export const SBERID_FINALIZE = "/api/questionnaire/v2/draft/sberid/finalize";
export const DRAFT_IDENTIFICATION = "/api/questionnaire/v2/draft/identification";
export const PERSONAL_DATA_FULLNAME_SUGGEST =
  "/api/questionnaire/v1/personal-data/fullname/suggest";
export const OFFER_HTML = "/api/questionnaire/v1/offer/html";
export const OFFER_GET_INSTRUCTION = "api/questionnaire/v1/offer/get-instruction";
export const OFFER_GET_AGREEMENT = "api/questionnaire/v1/offer/get-agreement";
export const OFFER_GET_PDF = "api/questionnaire/v1/offer/get-pdf";
export const OFFER_CONFIRM_AGREEMENT = "/api/questionnaire/v1/offer/confirm-agreement";
export const OFFER_UPLOAD = "/api/questionnaire/v1/offer/upload?questionnaire_uid";
export const OFFER_REMOVE_FILE = "/api/questionnaire/v1/offer/remove-file-and-url";
export const OFFER_SET_URL = "/api/questionnaire/v1/offer/set-url";
export const GENERATE_LOGO = "/api/questionnaire/v1/helper/logo-suggest";
export const DOMAIN_SUGGEST_BY_PRODUCT_DESCRIPTION =
  "/api/questionnaire/v1/helper/domain-suggest/by-product-description";
export const GENERATE_LOGO_BY_CLIENT_INFO = "/api/questionnaire/v1/draft/logo-suggest";
export const GENERATE_LOGO_LIST_BY_CLIENT_INFO = "/api/questionnaire/v1/draft/suggested-logo";
export const DRAFT_FEEDBACK = "/api/questionnaire/v1/questionnaire/feedback";
export const STATIC_DOCUMENT = "api/questionnaire/v1/helper/static-document";
export const VALIDATE_WEBSITES = "/api/questionnaire/v1/helper/validate-websites";
export const PROMOCODE_CHECK_AVAILABILITY = "/api/promocodes/v1/promocode/check-availability";
export const PRODAMUS_OFFER_TOGGLE_CHECKBOX =
  "/api/questionnaire/v1/prodamus-offer/toggle-checkbox";
export const TAXONOMY_STEP_FEEDBACK_OPTIONS =
  "/api/questionnaire/v1/taxonomy/step-feedback-options";
export const DRAFT_STEP_FEEDBACK = "/api/questionnaire/v1/draft/step-feedback";
